import {useAction} from '@karpeleslab/klb-react-services';
import {useCallback} from 'react';

export const useAffiliateCreateStripeAccount = () => {
	const [_doAction, loading] = useAction('Affiliate/@:stripeCreateAccount', 'POST');

	const doAction = useCallback((countryId, settingsOverride = {}) => _doAction({
		country: countryId,
	}, settingsOverride), []);

	return [doAction, loading];
};


export const useAffiliateGetStripeAccountDashboard = () => {
	const [_doAction, loading] = useAction('Affiliate/@:stripeAccountDashboardUrl', 'POST');

	const doAction = useCallback((settingsOverride = {}) => _doAction({}, settingsOverride), []);

	return [doAction, loading];
};


export const useAffiliateCreateStripeAccountAndGetUrl = () => {
	const [createAccount, creating] = useAffiliateCreateStripeAccount();
	const [getAccount, gettingAccount] = useAffiliateGetStripeAccountDashboard();

	const _doAction = useCallback((countryId, settingsOverride = {}) => {
		return createAccount(countryId, {
			innerThen: () => getAccount(settingsOverride),
			snackMessageToken: (settingsOverride ?? {}).snackMessageToken
		});
	}, [createAccount, getAccount]);

	return [_doAction, creating || gettingAccount];
};
